"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _voidCheque = _interopRequireDefault(require("../../assets/void-cheque.png"));
var _frenchVoidCheque = _interopRequireDefault(require("../../assets/french-void-cheque.jpg"));
var _EftDetailsForm = _interopRequireDefault(require("./EftDetailsForm"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
* Component for editing banking details.
*
* @component
* @param {Object} props - React component props.
* @param {Function} props.showPage - Function to switch between pages.
* @param {Object} props.currentBankingDetails - Current banking details.
* @param {Object} props.meta - Metadata related to banking details.
* @param {Function} props.saveNewBankingDetails - Function to save new banking details.
* @param {Object} props.whitelabel - Whitelabel configuration.
* @returns {JSX.Element} JSX element representing the banking details editing form.
*/
var EditBankingDetails = function EditBankingDetails(_ref) {
  var _currentBankingDetail, _currentBankingDetail2;
  var _ref$modalOpen = _ref.modalOpen,
    modalOpen = _ref$modalOpen === void 0 ? true : _ref$modalOpen,
    onBack = _ref.onBack,
    showModal = _ref.showModal,
    currentBankingDetails = _ref.currentBankingDetails,
    meta = _ref.meta,
    saveNewBankingDetails = _ref.saveNewBankingDetails,
    close = _ref.close,
    whitelabel = _ref.whitelabel,
    bankingDetailsVerifying = _ref.bankingDetailsVerifying,
    validateBankingDetails = _ref.validateBankingDetails,
    _ref$accountLevelBank = _ref.accountLevelBankingDetailsView,
    accountLevelBankingDetailsView = _ref$accountLevelBank === void 0 ? false : _ref$accountLevelBank,
    _ref$closeModalAfterS = _ref.closeModalAfterSaving,
    closeModalAfterSaving = _ref$closeModalAfterS === void 0 ? false : _ref$closeModalAfterS,
    _ref$isModal = _ref.isModal,
    isModal = _ref$isModal === void 0 ? true : _ref$isModal,
    customModalWidth = _ref.customModalWidth;
  var hasDualBankAccountSetup = accountLevelBankingDetailsView ? false : (currentBankingDetails === null || currentBankingDetails === void 0 ? void 0 : currentBankingDetails["default"]) && (currentBankingDetails === null || currentBankingDetails === void 0 || (_currentBankingDetail = currentBankingDetails.paymentsOnly) === null || _currentBankingDetail === void 0 ? void 0 : _currentBankingDetail.accountNum) && (currentBankingDetails === null || currentBankingDetails === void 0 || (_currentBankingDetail2 = currentBankingDetails.paymentsOnly) === null || _currentBankingDetail2 === void 0 ? void 0 : _currentBankingDetail2.accountNum.length) > 0;
  var chequeImage = _index.i18n.locale === "fr" ? _frenchVoidCheque["default"] : _voidCheque["default"];
  var _useState = (0, _react.useState)({
      useSameBankAccount: !hasDualBankAccountSetup,
      "default": {
        accountHolder: '',
        institutionName: '',
        institutionAddress: '',
        institutionNum: '',
        transitNum: '',
        accountNum: '',
        isValidated: false,
        accepted: false,
        timestampOfAcceptance: null,
        accountHolderError: false,
        institutionNumError: false,
        transitNumError: false,
        accountNumError: false,
        acceptedError: false,
        branchValidationError: false
      },
      paymentsOnly: {
        accountHolder: '',
        institutionName: '',
        institutionAddress: '',
        institutionNum: '',
        transitNum: '',
        accountNum: '',
        isValidated: false,
        accepted: false,
        timestampOfAcceptance: null,
        accountHolderError: false,
        institutionNumError: false,
        transitNumError: false,
        accountNumError: false,
        acceptedError: false,
        branchValidationError: false
      }
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    eftDetails = _useState2[0],
    setEftDetails = _useState2[1];

  /**
   * Updates the state of the parent component with changes specific to a form type in the banking details.
   *
   * @param {string} formType - The type of form (e.g., "default", "paymentsOnly").
   * @param {Object} newState - The new state changes for the specified form type.
   * @param {string} newState.property - The specific property to update within the form type.
   * @param {*} newState.value - The new value to set for the specified property.
   * 
   */
  var _handleStateChanges = function _handleStateChanges(formType, newState) {
    setEftDetails(function (prevEftDetails) {
      return _objectSpread(_objectSpread({}, prevEftDetails), {}, (0, _defineProperty2["default"])({}, formType, _objectSpread(_objectSpread({}, prevEftDetails[formType]), newState)));
    });
  };

  /**
   * Handles changes in the input values for a specified form type in banking details.
   *
   * @function
   * @private
   * @param {string} formType - The type of form (e.g., "default", "paymentsOnly").
   * @param {string} type - The specific property to update within the form type.
   * @param {*} value - The new value to set for the specified property.
   * @param {Event} event - The event triggering the change.
   */
  var _handleChange = function _handleChange(formType, type, value, event) {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    setEftDetails(function (prevEftDetails) {
      var updatedFormValue = _objectSpread(_objectSpread({}, prevEftDetails[formType]), {}, (0, _defineProperty2["default"])({}, type, value));
      if (type === 'accepted' && value === true) {
        updatedFormValue.timestampOfAcceptance = dates.getUTC();
      }
      return _objectSpread(_objectSpread({}, prevEftDetails), {}, (0, _defineProperty2["default"])({}, formType, updatedFormValue));
    });
  };

  /**
   * Validates the specified form type in the banking details by checking input fields against predefined rules.
   *
   * @async
   * @function
   * @param {string} formType - The type of form to validate (e.g., "default", "paymentsOnly").
   * @returns {boolean} Returns true if the specified form is successfully validated, false otherwise.
   * 
   */
  var validateForm = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(formType) {
      var form, accountHolderError, institutionNumError, transitNumError, accountNumError, acceptedError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            form = eftDetails[formType];
            _context.next = 3;
            return _index.Services.validateInput('bankAccountHolderName', form.accountHolder);
          case 3:
            accountHolderError = _context.sent;
            _context.next = 6;
            return _index.Services.validateInput('institutionNum', form.institutionNum);
          case 6:
            institutionNumError = _context.sent;
            _context.next = 9;
            return _index.Services.validateInput('transitNum', form.transitNum);
          case 9:
            transitNumError = _context.sent;
            _context.next = 12;
            return _index.Services.validateInput('checkEmpty', form.accountNum);
          case 12:
            accountNumError = _context.sent;
            acceptedError = form.accepted ? null : _index.i18n.t(_index.tokens.labels.banking.youMustAcceptTermsError);
            _handleStateChanges(formType, {
              accountHolderError: accountHolderError,
              institutionNumError: institutionNumError,
              transitNumError: transitNumError,
              accountNumError: accountNumError,
              acceptedError: acceptedError
            });
            return _context.abrupt("return", !accountHolderError && !institutionNumError && !transitNumError && !accountNumError && !acceptedError);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Validates the banking details forms based on the current configuration.
   *
   * @async
   * @function
   * @private
   * @returns {Promise<boolean>} Resolves with true if the forms are successfully validated, false otherwise.
   */
  var _validateForms = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var isDefaultFormValid, isPaymentsOnlyFormValid;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!eftDetails.useSameBankAccount) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", validateForm('default'));
          case 2:
            _context2.next = 4;
            return validateForm('default');
          case 4:
            isDefaultFormValid = _context2.sent;
            _context2.next = 7;
            return validateForm('paymentsOnly');
          case 7:
            isPaymentsOnlyFormValid = _context2.sent;
            return _context2.abrupt("return", isDefaultFormValid && isPaymentsOnlyFormValid);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function _validateForms() {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * Handles fetching and validating branch details for the provided institution and transit numbers.
   *
   * @async
   * @returns {boolean} Returns true if branch details are successfully validated, false otherwise.
   * @private
   */
  var validateBranchDetails = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(formType) {
      var branchDetails, _branchDetails$data, frenchInstitutionName, englishInstitutionName, branchDomicile, civicAddress, townCity, provinceCode, postalCode, validatedInstitutionName, validatedInstitutionAddress;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return validateBankingDetails(eftDetails[formType].institutionNum, eftDetails[formType].transitNum);
          case 2:
            branchDetails = _context3.sent;
            if (!(branchDetails.data === null && branchDetails.isFound === false)) {
              _context3.next = 6;
              break;
            }
            _handleChange(formType, 'branchValidationError', true);
            return _context3.abrupt("return", false);
          case 6:
            _branchDetails$data = branchDetails.data, frenchInstitutionName = _branchDetails$data.frenchInstitutionName, englishInstitutionName = _branchDetails$data.englishInstitutionName, branchDomicile = _branchDetails$data.branchDomicile, civicAddress = _branchDetails$data.civicAddress, townCity = _branchDetails$data.townCity, provinceCode = _branchDetails$data.provinceCode, postalCode = _branchDetails$data.postalCode;
            validatedInstitutionName = _index.i18n.locale === 'fr' ? frenchInstitutionName : englishInstitutionName;
            validatedInstitutionAddress = [branchDomicile, civicAddress, townCity, provinceCode, postalCode].join(', ');
            _handleStateChanges(formType, {
              institutionName: validatedInstitutionName,
              institutionAddress: validatedInstitutionAddress,
              institutionNumError: null,
              transitNumError: null,
              branchValidationError: false,
              isValidated: true
            });
            return _context3.abrupt("return", true);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function validateBranchDetails(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  /**
   * Validates banking details by checking form validations and branch details for different form types.
   *
   * @async
   * @private
   * @function
   * @returns {boolean} Returns true if banking details are successfully validated, false otherwise.
   * 
   */
  var _validateBankingDetails = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var formsValidated, isDefaultBranchValid, isPaymentsOnlyBranchValid;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _validateForms();
          case 2:
            formsValidated = _context4.sent;
            if (formsValidated) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return", false);
          case 5:
            if (!eftDetails.useSameBankAccount) {
              _context4.next = 7;
              break;
            }
            return _context4.abrupt("return", validateBranchDetails('default'));
          case 7:
            _context4.next = 9;
            return validateBranchDetails('default');
          case 9:
            isDefaultBranchValid = _context4.sent;
            _context4.next = 12;
            return validateBranchDetails('paymentsOnly');
          case 12:
            isPaymentsOnlyBranchValid = _context4.sent;
            return _context4.abrupt("return", isDefaultBranchValid && isPaymentsOnlyBranchValid);
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function _validateBankingDetails() {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
  * Saves the banking details, triggers the `saveNewBankingDetails` function, and shows the 'confirmDetails' modal.
  *
  * @async
  * @private
  * @function
  * 
  */
  var _saveBankingDetailsAndContinue = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var validatedBankingDetails;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            validatedBankingDetails = {
              useSameBankAccount: eftDetails.useSameBankAccount,
              "default": {
                accountHolder: eftDetails["default"].accountHolder,
                institutionName: eftDetails["default"].institutionName,
                institutionAddress: eftDetails["default"].institutionAddress,
                institutionNum: "".concat(eftDetails["default"].institutionNum),
                transitNum: "".concat(eftDetails["default"].transitNum),
                accountNum: "".concat(eftDetails["default"].accountNum),
                accepted: eftDetails["default"].accepted,
                timestampOfAcceptance: Number(eftDetails["default"].timestampOfAcceptance)
              }
            };
            if (!accountLevelBankingDetailsView && !eftDetails.useSameBankAccount) {
              validatedBankingDetails.paymentsOnly = {
                accountHolder: eftDetails.paymentsOnly.accountHolder,
                institutionName: eftDetails.paymentsOnly.institutionName,
                institutionAddress: eftDetails.paymentsOnly.institutionAddress,
                institutionNum: "".concat(eftDetails.paymentsOnly.institutionNum),
                transitNum: "".concat(eftDetails.paymentsOnly.transitNum),
                accountNum: "".concat(eftDetails.paymentsOnly.accountNum),
                accepted: eftDetails.paymentsOnly.accepted,
                timestampOfAcceptance: Number(eftDetails.paymentsOnly.timestampOfAcceptance)
              };
            }
            _context5.next = 4;
            return saveNewBankingDetails(validatedBankingDetails);
          case 4:
            showModal && showModal('confirmDetails');
            closeModalAfterSaving && close();
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function _saveBankingDetailsAndContinue() {
      return _ref6.apply(this, arguments);
    };
  }();

  /**
   * Handles the onSave action for the banking details form:
   * - If using the same bank account and default details are not validated, triggers banking details validation.
   * - If not using the same account and either default or payments-only details are not validated, triggers banking details validation.
   * - Otherwise, saves the banking details and continues to the next step.
   *
   * @async
   * @function
   * @returns {Promise<void|null>} Resolves with null if validation is triggered, otherwise resolves after saving and continuing.
   * @throws {Error} Throws an error if any translation token is missing or if an unexpected condition occurs.
   * 
   */
  var onSave = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var isSameBankAccount, isDefaultValidated, isPaymentsOnlyValidated;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            isSameBankAccount = eftDetails.useSameBankAccount;
            isDefaultValidated = eftDetails["default"].isValidated;
            isPaymentsOnlyValidated = eftDetails.paymentsOnly.isValidated;
            if (!(isSameBankAccount && !isDefaultValidated)) {
              _context6.next = 9;
              break;
            }
            _context6.next = 6;
            return _validateBankingDetails();
          case 6:
            return _context6.abrupt("return", _context6.sent);
          case 9:
            if (!(!isSameBankAccount && (!isDefaultValidated || !isPaymentsOnlyValidated))) {
              _context6.next = 13;
              break;
            }
            _context6.next = 12;
            return _validateBankingDetails();
          case 12:
            return _context6.abrupt("return", _context6.sent);
          case 13:
            _context6.next = 15;
            return _saveBankingDetailsAndContinue();
          case 15:
            return _context6.abrupt("return", _context6.sent);
          case 16:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function onSave() {
      return _ref7.apply(this, arguments);
    };
  }();

  /**
   * Generates the save button text based on the current state:
   * - If banking details are being verified, displays "Validating."
   * - If using the same bank account and default details are validated, shows "Save Banking Details."
   * - If not using the same account and both default and payments-only details are validated, shows "Save Banking Details."
   * - Otherwise, displays "Validate Banking Details."
   *
   * @function
   * @returns {string} The text for the save button.
   * 
   */
  var saveButtonText = bankingDetailsVerifying ? _index.i18n.t(_index.tokens.labels.banking.validating).toUpperCase() : eftDetails.useSameBankAccount ? eftDetails["default"].isValidated ? _index.i18n.t(_index.tokens.buttons.save).toUpperCase() : _index.i18n.t(_index.tokens.labels.banking.validateBanking).toUpperCase() : eftDetails["default"].isValidated && eftDetails.paymentsOnly.isValidated ? _index.i18n.t(_index.tokens.buttons.save).toUpperCase() : _index.i18n.t(_index.tokens.labels.banking.validateBanking).toUpperCase();

  /**
   * 
   * @returns 
   */
  var editBankingForm = function editBankingForm() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, meta !== null && meta !== void 0 && meta.paymentsSetup && (meta === null || meta === void 0 ? void 0 : meta.paymentsSetup) === 1 ? /*#__PURE__*/_react["default"].createElement(_index.Text, {
      medium: true,
      light: true
    }, _index.i18n.t(_index.tokens.labels.banking.youHaveAlreadySubmittedBankingDetails)) : null, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      small: true,
      margin: "20px 0"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: 14
      }
    }, "".concat(_index.i18n.t(_index.tokens.labels.banking.example), ": ")), _index.i18n.t(_index.tokens.labels.banking.followingInformationFoundOnCheque)), /*#__PURE__*/_react["default"].createElement("img", {
      alt: "Example Cheque",
      src: chequeImage,
      style: {
        width: '100%',
        height: '100%'
      }
    }), !accountLevelBankingDetailsView ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (meta === null || meta === void 0 ? void 0 : meta.paymentType) !== 'CC' && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
      component: "fieldset"
    }, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      small: true,
      margin: "30px 0 0 0"
    }, _index.i18n.t(_index.tokens.labels.banking.wouldYouLikeToUseTheSameBankAccounts)), /*#__PURE__*/_react["default"].createElement(_index.BubbleSelectBlock, {
      first: {
        title: _index.i18n.t(_index.tokens.buttons.yes),
        selected: eftDetails.useSameBankAccount === true,
        field: 'useSameBankAccountYes'
      },
      second: {
        title: _index.i18n.t(_index.tokens.buttons.no),
        selected: eftDetails.useSameBankAccount === false,
        field: 'useSameBankAccountNo'
      },
      handleChange: function handleChange() {
        setEftDetails(function (prevEftDetails) {
          return _objectSpread(_objectSpread({}, prevEftDetails), {}, {
            useSameBankAccount: !eftDetails.useSameBankAccount
          });
        });
      }
    }))) : null, accountLevelBankingDetailsView || eftDetails.useSameBankAccount ? /*#__PURE__*/_react["default"].createElement(_EftDetailsForm["default"], {
      formType: "default",
      eftDetails: eftDetails,
      handleStateChanges: _handleStateChanges,
      handleChange: _handleChange,
      whitelabel: whitelabel,
      accountLevelBankingDetailsView: accountLevelBankingDetailsView
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_EftDetailsForm["default"], {
      formType: "default",
      eftDetails: eftDetails,
      handleStateChanges: _handleStateChanges,
      handleChange: _handleChange,
      whitelabel: whitelabel,
      accountLevelBankingDetailsView: accountLevelBankingDetailsView
    }), /*#__PURE__*/_react["default"].createElement(_EftDetailsForm["default"], {
      formType: 'paymentsOnly',
      eftDetails: eftDetails,
      handleStateChanges: _handleStateChanges,
      handleChange: _handleChange,
      whitelabel: whitelabel,
      accountLevelBankingDetailsView: accountLevelBankingDetailsView
    })));
  };
  if (!isModal) {
    return editBankingForm();
  }
  return /*#__PURE__*/_react["default"].createElement(_index.FormModal, {
    open: modalOpen,
    onBack: onBack,
    close: close,
    title: _index.i18n.t(_index.tokens.labels.banking.changeBankingDetails),
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    onSave: onSave,
    saveButtonText: saveButtonText,
    customContainerStyle: {
      width: customModalWidth || 1000
    },
    maxWidth: "lg"
  }, editBankingForm());
};
var _default = exports["default"] = EditBankingDetails;